let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1H3ib")).then(() => parcelRequire('9tFBF'));